import React, { useLayoutEffect } from "react"
import PropTypes from "prop-types";
import Immutable from "immutable";
import { connect } from "react-redux";
import { DEFAULT_PAGE_SIZE } from "../../../../config/constants";
import ModuleList from "../../../layout/ModuleList";
import { DOCUMENT_TYPE_PATH, NEW_DOCUMENT_TYPE_PATH } from "../../../../config/paths";
import { breadcrumbsPropTypes } from "../../../common/resource/proptypes/CommonPropTypes";
import { DOCUMENT_TYPE_COLUMN } from "../../../../config/columns";
import { clearDocumentTypes, getDocumentTypes } from "../../../../actions";

export const DocumentTypes = (
    {
  breadcrumbs,
  documentTypes,
  loading,
  dispatchGetDocumentTypes,
  dispatchClearDocumentTypes,
}
) => {
    useLayoutEffect(()=>()=>dispatchClearDocumentTypes(), []);

    const data = documentTypes.get('content') || [];
    const pages = documentTypes.get('totalPages') || null;
    const defaultPageSize = documentTypes.get('size') || DEFAULT_PAGE_SIZE;

    return (
    <ModuleList
        title="Tipos de Documento"
        breadcrumbs={breadcrumbs}
        buttonPath={NEW_DOCUMENT_TYPE_PATH}
        tableStructure={{
        columns: DOCUMENT_TYPE_COLUMN,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetDocumentTypes,
        modelPath: DOCUMENT_TYPE_PATH,
        loading,
        navigateToModelOnRowClick: true,
        }}
    />
    ); 
}

const mapDispatchToProps = {
  dispatchGetDocumentTypes: getDocumentTypes,
  dispatchClearDocumentTypes: clearDocumentTypes,
};

const mapStateToProps = ({ BusUnit }) => ({
  breadcrumbs: [
    ...BusUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tipos de Documento',
      href: DOCUMENT_TYPE_PATH,
    },
  ],
  documentTypes: BusUnit.DocumentType.getIn(['all', 'content']),
  loading: BusUnit.DocumentType.getIn(['all', 'loading']),
});

DocumentTypes.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  documentTypes: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetDocumentTypes: PropTypes.func.isRequired,
  dispatchClearDocumentTypes: PropTypes.func.isRequired,
};

DocumentTypes.defaultProps = {
  documentTypes: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentTypes);